
    
    import { defineComponent } from 'vue';
    import * as yup from "yup";
    
    export default defineComponent({
        components: {
            
        },
        data() {
            return {
            }
        },
        computed: {
            schema(): object {
                return yup.object().shape({
                    form: yup.object({
                    })
                });
            }
        },
        methods: {
            
        }
    });
